<script setup>
import { computed } from 'vue';
import { hubSignInName } from '../../helpers/hubSignInName';

const props = defineProps({
  logo: {
    type: String,
    default: '',
  },
});

const hubName = computed(hubSignInName);
</script>

<template>
  <div v-if="props.logo" class="logo">
    <img :src="props.logo" :alt="hubName || 'Logo'">
  </div>
  <div v-else-if="hubName" class="logo logo__name">{{ hubName }}</div>
</template>

<style lang="scss" scoped>
.logo {
  margin: 0 auto 30px auto;
  img {
    display: block;
    width: 100%;
  }
}

.logo__name {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  overflow-wrap: anywhere;
  color: var(--xl-color-primary-text, #1e1a1f);
}
</style>
